import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import Button from '../../incase-domain/components/button/Button';
import BaseFileLoader, {FileResult} from './BaseFileLoader';

interface VideoFileLoaderProps {
    onLoad: (files: FileResult[]) => void;
    multipleFiles?: boolean;
    child?: JSX.Element;
    hasExistingVideo?: boolean;
    inputRef?: React.RefObject<HTMLInputElement>;
}

function VideoFileLoader(props: VideoFileLoaderProps): ReactElement {
    const {onLoad, multipleFiles = false, child, hasExistingVideo = false, inputRef} = props;
    const {t} = useTranslation();

    const getVideoButton = (): JSX.Element => (
        <Button variant="soft" color="secondary" size="sm" fullWidth leading="ph:plus-bold">
            {hasExistingVideo ? t('designSidepanel.replaceVideo') : t('designSidepanel.selectVideo')}
        </Button>
    );

    return (
        <BaseFileLoader
            inputRef={inputRef}
            accept="video/*"
            onLoad={onLoad}
            type="video"
            multipleFiles={multipleFiles}
            child={child || getVideoButton()}
        />
    );
}

export default VideoFileLoader;
